export default __webpack_public_path__ + "02da2a6bd9f5b1d17319a1ce061548a2.png";